import { Button } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Id } from '@feature/utils';

interface VerifyEvaluationButtonProps {
  evaluationId: Id;
}

export function VerifyEvaluationButton({ evaluationId }: VerifyEvaluationButtonProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = () => {
    navigate({
      to: `/evaluation/$evaluationId/report/gather`,
      params: { evaluationId: String(evaluationId) },
      search: true,
    });
  };

  return (
    <Button
      size="xs"
      onClick={onClick}
    >
      {t('evaluation.verifyReporting')}
    </Button>
  );
}
